define("settings/services/settings", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/service", "@ember/string", "ember-concurrency", "later/errors/fetch", "later/utils/fetch", "later/utils/time-format", "settings/utils/handle-settings-error"], function (_exports, _asyncArrowRuntime, _service, _string, _emberConcurrency, _fetch, _fetch2, _timeFormat, _handleSettingsError) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/service",0,"@ember/string",0,"ember-concurrency",0,"later/errors/fetch",0,"later/utils/fetch",0,"later/utils/time-format",0,"settings/utils/handle-settings-error"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let SettingsService = _exports.default = (_class = class SettingsService extends _service.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _initializerDefineProperty(this, "errors", _descriptor4, this);
      _initializerDefineProperty(this, "intl", _descriptor5, this);
      _initializerDefineProperty(this, "payment", _descriptor6, this);
      _initializerDefineProperty(this, "router", _descriptor7, this);
      _initializerDefineProperty(this, "segment", _descriptor8, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor9, this);
      /**
       * A task that submits a form and handles the success and error cases
       *
       * @property submitForm
       * @param submitMethod A running Promise that will settle at some point in the future
       * @param translationPathThe path to look up when finding translation
       * messages for the alert that is being built.
       * @param [messageArgs] Optional arguments to be passed into success message string.
       * @param [titleArgs] Optional arguments to be passed into success title string.
       *
       * @returns A Success Alerts Object to optionally be used by the caller for display purposes.
       */
      _defineProperty(this, "submitForm", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (submitMethod, translationPath) {
          var _this = this;
          let messageArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          let titleArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          return function* () {
            try {
              const response = yield submitMethod;
              return {
                alert: {
                  type: 'success',
                  message: _this.intl.t(translationPath + '.success.message', messageArgs),
                  title: _this.intl.t(translationPath + '.success.title', titleArgs)
                },
                response
              };
            } catch (error) {
              if (error instanceof _fetch.FetchError) {
                // @ts-expect-error message could be an object
                error.resolve.call(_this, _this.intl.t('alerts.generic_error_message'), error.message?.title ?? error.message);
                return;
              }
              throw (0, _handleSettingsError.default)(error, translationPath, _this.intl);
            }
          }();
        }
      }), null, "submitForm", null));
      /**
       * A task that submits a form and handles the success and error cases
       *
       * @property submitFormWithDynamicDisplay
       * @param submitMethod A running Promise that will settle at some point in the future
       * @param dynamicAlertMessage Dynamic section to use within the success/error message (group name, etc)
       * @param translationPath The path to look up when finding translation
       * messages for the alert that is being built.
       *
       * @returns A Success Alerts Object to optionally be used by the caller for display purposes.
       */
      _defineProperty(this, "submitFormWithDynamicDisplay", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (submitMethod, dynamicString, translationPath) {
          try {
            const response = yield submitMethod;
            return {
              alert: {
                type: 'success',
                message: this.intl.t(translationPath + '.success.message', {
                  dynamic: dynamicString
                }),
                title: this.intl.t(translationPath + '.success.title')
              },
              response
            };
          } catch (error) {
            if (error instanceof _fetch.FetchError) {
              error.resolve.call(this, this.intl.t(translationPath + '.error.title'), error.message);
              return;
            }
            throw (0, _handleSettingsError.default)(error, translationPath, this.intl);
          }
        }
      }), null, "submitFormWithDynamicDisplay", null));
      /**
       * A task that tracks `clicked-change-plan`.
       * Makes an api call to get account stats to send with the event.
       *
       * @property trackChangePlan
       */
      _defineProperty(this, "trackChangePlan", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const {
            name: planName,
            monthlyRate
          } = this.subscription;
          const response = yield (0, _fetch2.fetch)('/api/v2/cancellation_stats.json');
          this.segment.track('clicked-change-plan', {
            paid_plan: planName,
            monthly_spend: monthlyRate,
            days_on_plan: response.days_on_plan,
            num_posts_sched: response.num_posts_scheduled,
            num_posts_posted: response.num_posts_posted
          }, {
            follower_count: 'currentAccount.mainProfile.followedBy',
            main_profile_industry: 'currentAccount.mainProfile.industry',
            main_profile_business_model: 'currentAccount.mainProfile.businessModel'
          });
        }
      }), null, "trackChangePlan", null));
      /**
       * A task that reactivates a paid account and tracks `clicked-reactivate-paid-account`.
       * Makes an api call to get account stats to send with the event.
       *
       * @property reactivateCancelledPlan
       */
      _defineProperty(this, "reactivateCancelledPlan", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            const {
              additionalUsers,
              additionalSocialSets,
              additionalAiCredits,
              name: planName,
              monthlyRate
            } = this.subscription;
            const {
              stripePlanId: planId
            } = this.subscriptions.subscriptionPlan;
            const stats = yield (0, _fetch2.fetch)('/api/v2/cancellation_stats.json');
            this.segment.track('clicked-reactivate-paid-account', {
              page: this.currentRouteName,
              paid_plan: planName,
              monthly_spend: monthlyRate,
              days_on_plan: stats.days_on_plan,
              num_posts_sched: stats.num_posts_scheduled,
              num_posts_posted: stats.num_posts_posted
            }, {
              follower_count: 'currentAccount.mainProfile.followedBy',
              main_profile_industry: 'currentAccount.mainProfile.industry',
              main_profile_business_model: 'currentAccount.mainProfile.businessModel'
            });
            yield this.payment.changePlan({
              stripePlanId: planId,
              additionalUsers,
              additionalSocialSets,
              additionalAiCredits
            });
            this.alerts.success(this.intl.t('alerts.account.overview.subscription_overview.reactivate_success.message', {
              plan: (0, _string.capitalize)(planName)
            }), {
              title: this.intl.t('alerts.account.overview.subscription_overview.reactivate_success.title', {
                plan: (0, _string.capitalize)(planName)
              }),
              timeout: 5000
            });
          } catch (error) {
            this.errors.handleAjax(error);
          }
        }
      }), null, "reactivateCancelledPlan", "drop"));
      /**
       * A task that tracks `clicked-reactivation-training`.
       * Makes an api call to get account stats to send with the event.
       *
       * @property trackClickedTraining
       */
      _defineProperty(this, "trackClickedTraining", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const {
            name: planName,
            monthlyRate
          } = this.subscription;
          const stats = yield (0, _fetch2.fetch)('/api/v2/cancellation_stats.json');
          this.segment.track('clicked-reactivation-training', {
            page: this.currentRouteName,
            paid_plan: planName,
            monthly_spend: monthlyRate,
            days_on_plan: stats.days_on_plan,
            num_posts_sched: stats.num_posts_scheduled,
            num_posts_posted: stats.num_posts_posted
          }, {
            follower_count: 'currentAccount.mainProfile.followedBy',
            main_profile_industry: 'currentAccount.mainProfile.industry',
            main_profile_business_model: 'currentAccount.mainProfile.businessModel'
          });
        }
      }), null, "trackClickedTraining", null));
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get currentRouteName() {
      return this.router.currentRouteName;
    }
    get isAccountOwner() {
      return this.auth.currentUserModel.isAccountOwner;
    }
    get accountOwnerEmail() {
      return this.currentAccount.owner.get('email');
    }
    get subscription() {
      return this.subscriptions.subscription;
    }
    get onlyInContributorGroups() {
      return this.auth.groups.every(group => group.contributor);
    }
    get canCreateNewGroup() {
      return this.currentAccount.canCluster || this.onlyInContributorGroups;
    }
    get isNewSubscriber() {
      if (!this.subscriptions.subscriptionCreatedAt) {
        return false;
      }
      const createdAt = _timeFormat.convert.seconds(this.subscriptions.subscriptionCreatedAt).toMilliseconds();
      const daysSincePaid = (Date.now() - createdAt) / _timeFormat.convert.day().toMilliseconds();
      const thresholdForNewUser = 35;
      return daysSincePaid <= thresholdForNewUser;
    }

    /**
     * Displays an "Are you sure" dialogManager Confirm screen
     * if the provided condition is truthy.
     *
     * @method confirmClose
     * @param condition an expression that either evaluates truthy or falsey
     *
     * @returns Resolves if the confirm modal was accepted, or if the conditional was falsey.
     *  Rejects if the confirm modal was declined
     */
    async confirmClose(condition) {
      if (!condition) {
        return;
      }
      const didConfirm = await this.dialogManager.confirmation(this.intl.t('account.overview.basic_information.confirm_close.title'), {
        description: this.intl.t('account.overview.basic_information.confirm_close.message')
      });
      if (didConfirm) {
        return;
      }
      return Promise.reject();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});